import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tanggeng",
  "use": "icon-tanggeng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-tanggeng\"><defs><style type=\"text/css\"></style></defs><path d=\"M643.9 775.9c-3.9 0-7.9-0.6-11.8-1.7-22.1-6.5-34.7-29.7-28.2-51.7l154.7-525.3C780.1 124 856 81.7 927.7 102.8c22.1 6.5 34.7 29.7 28.2 51.7-5.3 18.1-22 29.9-40 29.9-3.9 0-7.9-0.6-11.8-1.7-27.6-8.1-57 8.9-65.6 38L683.9 746c-5.3 18.2-22 29.9-40 29.9z\" p-id=\"67297\" fill=\"#707070\" /><path d=\"M391.4 964.8c-24.9 0-50-3-74.7-9.1-71.9-17.8-134.6-60.4-176.5-120-26-36.9-43.2-77.7-51.3-121.5-7.7-42-6.6-84.5 3.3-126.2 3.7-15.7 13.3-29 27-37.4 13.6-8.3 29.6-10.9 45.1-7.1l479.8 115.6c15.5 3.7 28.6 13.3 36.9 26.9 8.4 13.7 10.9 30 7 45.7-21.2 86.8-79.2 159.9-159.1 200.5-42.7 21.5-89.8 32.6-137.5 32.6zM208.3 787.6c63.3 89.8 184.9 119.9 282.8 70.1 51.2-26.1 90.1-70.4 109.2-123.6L169.1 630.2c-7.1 55.1 6.7 111.4 39.2 157.4z\" p-id=\"67298\" fill=\"#707070\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tanggeng.svg
// module id = oKcM
// module chunks = 22